import React from 'react';

import Text from '~components/atoms/Text';
import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';

import * as Styles from './_goldConversion.module.scss';
import GoldConversionTable from './GoldConversionTable';
import GoldConversionPaginator from './GoldConversionPaginator';
import GoldConversionSearchAndFilterBar from './GoldConversionSearchAndFilterBar';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import GoldConversionModal from './CreateGoldConversionModal';
import combinedActions from '~redux/combinedActions';
import ActionButton from '~components/atoms/ActionButton';
import { MetalTypeEnum, ModuleEnum, PermissionsEnum } from '~utils/enums';
import GoldConversionDetailsModal from './GoldConversionDetailsModal';

const GoldConversion = () => {
    const dispatch = useAppDispatch();

    const createAccessModules = useAppSelector(state => state.auth.userDetails.access)?.find(access => access.permission === PermissionsEnum.Create)?.modules || [];

    const isOpen = useAppSelector(state => state.gold.modals.isCreateGoldConversionModalOpen);

    const handleOpenCreateConversionModal = () => {
        dispatch(combinedActions.goldSetIsCreateGoldConversionModalOpen(true));
    };

    const handleOnCloseModal = () => {
        dispatch(combinedActions.goldSetIsCreateGoldConversionModalOpen(false));
    };

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Conversion'
                    className={Styles.title}
                    isBold
                />

                {
                    createAccessModules.find(module => module === ModuleEnum.Conversion)
                        &&
                        (
                            <ActionButton
                                testId='create-conversion-modal-open-button'
                                label='+ Create New Conversion'
                                onClick={handleOpenCreateConversionModal}
                            />
                        )
                }
            </TabPageHeaderWrapper>

            <GoldConversionSearchAndFilterBar />
            <GoldConversionTable />
            <GoldConversionPaginator />

            <GoldConversionModal isOpen={isOpen} onClose={handleOnCloseModal} />
        </TabPageContainer>
    );
};

export default GoldConversion;
